import ProductHistoryAppConfig from './DataAppConfig';

const ProductsHistoryAppConfig = [ProductHistoryAppConfig];

export default ProductsHistoryAppConfig;
